import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { Order } from '@/mocks/orders';
import KanbanCard from './KanbanCard';

interface KanbanColumnProps {
  id: string;
  title: string;
  color: string;
  orders: Order[];
  count: number;
}

export default function KanbanColumn({ id, title, color, orders, count }: KanbanColumnProps) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      className={`flex-shrink-0 w-[280px] flex flex-col rounded-xl transition-colors ${
        isOver ? 'bg-gold-50/50' : 'bg-stone-50'
      }`}
    >
      {/* Column Header */}
      <div className="flex items-center gap-2 px-3 py-3 sticky top-0 bg-stone-50 rounded-t-xl z-10">
        <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${color}`} />
        <h4 className="text-xs font-semibold text-stone-700 uppercase tracking-wide">{title}</h4>
        <span className="ml-auto text-xs text-stone-400 bg-stone-200/70 px-1.5 py-0.5 rounded-full font-medium">{count}</span>
      </div>

      {/* Cards */}
      <div
        ref={setNodeRef}
        className="flex-1 px-2 pb-2 space-y-2 min-h-[120px] overflow-y-auto"
      >
        <SortableContext items={orders.map(o => o.id)} strategy={verticalListSortingStrategy}>
          {orders.map((order) => (
            <KanbanCard key={order.id} order={order} />
          ))}
        </SortableContext>

        {orders.length === 0 && (
          <div className="flex items-center justify-center h-20 text-xs text-stone-300 border-2 border-dashed border-stone-200 rounded-lg">
            Sürükleyip bırakın
          </div>
        )}
      </div>
    </div>
  );
}